import * as THREE from "three";
import { useRef, useEffect } from "react";
import { useRoute, useLocation } from "wouter";
import { isMobile } from "react-device-detect";
import { useFrame } from "@react-three/fiber";
import { easing } from "maath";
import Frame from "./Frame";

const GOLDENRATIO = 1.61803398875;

function Frames({
  images,
  q = new THREE.Quaternion(),
  p = new THREE.Vector3(),
}: {
  images: any;
  q: THREE.Quaternion;
  p: THREE.Vector3;
}) {
  const ref = useRef<THREE.Group>(null!);
  const clicked = useRef<any>(null!);
  const [, params] = useRoute("/item/:id");
  const [, setLocation] = useLocation();

  useEffect(() => {
    clicked.current = ref.current.getObjectByName(params?.id || ".");
    if (clicked.current) {
      clicked.current.parent.updateWorldMatrix(true, true);
      clicked.current.parent.localToWorld(
        p.set(0, GOLDENRATIO / 2 + 0.15, isMobile ? 2.4 : 1.3)
      );
      clicked.current.parent.getWorldQuaternion(q);
    } else {
      p.set(0, 0.6, isMobile ? 9 : 4.5);
      q.identity();
    }
  });
  useFrame((state, dt) => {
    easing.damp3(state.camera.position, p, 0.4, dt);
    easing.dampQ(state.camera.quaternion, q, 0.4, dt);
  });

  return (
    <>
      <group
        ref={ref}
        onClick={(e) => {
          e.stopPropagation();
          setLocation(
            clicked.current === e.object ? "/" : "/item/" + e.object.name
          );
        }}
        onPointerMissed={() => setLocation("/")}
      >
        {images.map(
          (props: any) => <Frame key={props.url} {...props} /> /* prettier-ignore */
        )}
      </group>
    </>
  );
}

export default Frames;
